import React from 'react';
import TopSidebarViewSingleVoyage from "@containers/singleVoyage/views/topSidebar/TopSidebarViewSingleVoyage";
import {sx} from "./sx";
import RootNavigateSingleVoyage from "@containers/singleVoyage/navigate/rootNavigate/RootNavigateSingleVoyage";
import TopActionBarMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/views/actionBar/topActionBar/TopActionBarMutateSingleVoyage";
import BackBarMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/views/actionBar/backBar/BackBarMutateSingleVoyage";
import AccountSwitcherSingleVoyage from "@containers/singleVoyage/account/switcher/AccountSwitcherSingleVoyage";
import {PATH_MONITORING_SINGLE_VOYAGES} from "@constants/navigate";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";

const TopSidebarMutateSingleVoyage = () => {

    const {voyageId} = useRootContextMutateSingleVoyage()

    return (
        <TopSidebarViewSingleVoyage
            sx={sx.topSidebar}
        >
            <BackBarMutateSingleVoyage/>

            <AccountSwitcherSingleVoyage navigateTo={voyageId ? PATH_MONITORING_SINGLE_VOYAGES : undefined}/>

            <RootNavigateSingleVoyage/>

            <TopActionBarMutateSingleVoyage/>

        </TopSidebarViewSingleVoyage>
    );
};

export default TopSidebarMutateSingleVoyage;